import { Link } from "react-router-dom";
import {
    FaHome,
    FaUsers,
    FaFileInvoiceDollar,
    FaMoneyCheckAlt,
    FaChartBar,
    FaCog,
    FaSignOutAlt
} from "react-icons/fa";

export default function Sidebar() {

    return (

        <div className="sidebar">

            <div className="logo">

                <h3>Potech</h3>
                <small>Invoice System</small>

            </div>

            <ul>

                <li>
                    <Link to="/dashboard">
                        <FaHome /> Dashboard
                    </Link>
                </li>

                <li>
                    <Link to="/clients">
                        <FaUsers /> Clients
                    </Link>
                </li>

                <li>
                    <Link to="/invoices">
                        <FaFileInvoiceDollar /> Invoices
                    </Link>
                </li>

                <li>
                    <Link to="/payments">
                        <FaMoneyCheckAlt /> Payments
                    </Link>
                </li>

                <li>
                    <Link to="/reports">
                        <FaChartBar /> Reports
                    </Link>
                </li>

                <li>
                    <Link to="/settings">
                        <FaCog /> Settings
                    </Link>
                </li>

            </ul>

            <div className="logout">

                <button className="btn btn-danger w-100">

                    <FaSignOutAlt /> Logout

                </button>

            </div>

        </div>

    );

}